import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Router } from '@angular/router';
import { User } from '../../models/user';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-user-search',
  templateUrl: './user-search.component.html'
})
export class UserSearchComponent implements OnInit {
  @Input() exclude: User;
  @Input() action: string;
  @Output() actionCallback = new EventEmitter();
  users: User[] = [];
  loading: boolean = false; 
  private searchSubject = new Subject<string>(); 

  constructor(private user: UserService, private router: Router) { }

  ngOnInit() {
    this.searchSubject.pipe(
      debounceTime(300), 
      distinctUntilChanged(), 
      switchMap((searchTerm: string) => {
        if (!searchTerm.trim()) { 
          this.users = []; 
          this.loading = false; 
          return []; 
        }
        
        this.loading = true; 
        
        return this.user.search<Array<User>>(searchTerm.toLowerCase()).toPromise(); 
      })
    ).subscribe(users => {
      if (this.exclude) {
        users = users.filter(user => user.id !== this.exclude.id);
      }
      this.users = users;
      this.loading = false; 
    });
  }


  onSearch(val: string) {
    if (val.trim()) { 
      this.searchSubject.next(val);
    }
  }

  userSelected(user: User) {
    this.actionCallback.emit(user);
  }
}